/**
 * 인증 실패 이벤트 발행/구독
 *
 * axiosClient(React 바깥)와 SsoTokenProvider(React 안) 사이의 브리지.
 * 민감정보(토큰 원문, 사용자 식별자)는 payload에 담지 않는다.
 */

export type AuthFailureReason = 'TOKEN_EXPIRED' | 'INVALID_TOKEN' | 'ACCOUNT_DISABLED';

type Listener = (reason: AuthFailureReason) => void;

let listeners: Listener[] = [];
let fired = false;

export function emitAuthFailure(reason: AuthFailureReason): void {
  if (fired) return; // 동일 세션에서 중복 발행 방지
  if (listeners.length === 0) return; // 리스너 없으면 guard 올리지 않음
  fired = true;
  listeners.forEach((fn) => fn(reason));
}

export function subscribeAuthFailure(listener: Listener): () => void {
  listeners.push(listener);
  return () => {
    listeners = listeners.filter((fn) => fn !== listener);
  };
}

/** 재인증 완료 후 guard 초기화 */
export function resetAuthFailureState(): void {
  fired = false;
}
